import React from 'react';
import './style.css';

const Lucky15 = ({ detailResult = null, roundId = "N/A", matchTime = "" }) => {
  // Get run text from rdesc or win value
  const rdescText = detailResult?.rdesc || "";
  const winValue = detailResult?.win || "";
  const runText = rdescText || (winValue ? `${winValue} Run${winValue !== "1" ? "s" : ""}` : "");

  return (
    <div className=" lucky15-result">
      <div className="row">
        <div className="col-md-12">
          <h6 className="text-right">
            <b>Round Id :</b> {roundId}
          </h6>
        </div>
      </div>
      <div className="row mt-3 lucky15-ball-container">
        <img 
        style={{ marginRight: 'auto', width: '200px'}}
          className="lucky15-ball"
          src="https://d3kb8xz339pq18.cloudfront.net/v12/static/backend/images/cards/lucky15/ball-blank.png" 
          alt="Cricket Ball"
          onError={(e) => {
            e.target.src = "/assets/img/ball-blank.png";
          }}
        />
        <div className="ml-4 ballresult">{runText}</div>
      </div>
    </div>
  );
};

export default Lucky15;
